module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0139.jpg?v=dfbf5d93";